/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Area_ManagersInputs */

const en_nav_area_managers = /** @type {(inputs: Nav_Area_ManagersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area managers`)
};

/**
* | output |
* | --- |
* | "Area managers" |
*
* @param {Nav_Area_ManagersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_area_managers = /** @type {((inputs?: Nav_Area_ManagersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Area_ManagersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_area_managers(inputs)
});